import { NotificationDTO, NotificationTypes } from "containers/notifications/types/notifications";
import { useProfileById } from "containers/profile/hooks/useProfile";
import { useProject } from "containers/projects/hooks/useProjects";
import { NotificationBase } from "../NotificationBase";
import { Text } from "@/components/commons/typography/Text";
import { useNotificationTime } from "containers/notifications/hooks/notification-time";
import Link from "next/link";
import { getProfileLink } from "containers/profile/utilities/profile";
import { joinWithSlash } from "utilities/links";

interface NotificationItemProps {
  notification: Extract<NotificationDTO, { 
    notificationType:  NotificationTypes.NETWORK_PROJECT_CREATED }>
}

export const NotificationCreationProject = ({ notification }: NotificationItemProps) => {
  const { profile: ownerProfile, isLoading: loadingOwnerProfile } = useProfileById(notification.specificData.ownerId)
  const { project, isLoading: loadingProject } = useProject(notification.specificData.referencedId)
  
  const time = useNotificationTime(notification)

  const loading = loadingOwnerProfile || loadingProject

  return (
    <NotificationBase
      mainAvatar={ownerProfile?.avatar}
      mainUsername={ownerProfile?.username}
      secondaryAvatar={project?.gallery?.[0]}
      secondaryUsername={project?.title}
      loading={loading}
      time={time}
      >
        <div className='flex flex-column gap-14 justify-space-between'>
          <Text variation='small' weightClass='font-medium'>
            <Link href={getProfileLink(ownerProfile)}>
              <span className='font-bold'>{ownerProfile?.firstName} {ownerProfile?.lastName}</span>{' '}
            </Link>
            created a new project{' '}
            <Link href={joinWithSlash(
              getProfileLink(ownerProfile),
              'projects',
              project?.id
            )}>
              <span className='font-bold'>{project?.title}</span>
            </Link>
          </Text>
        </div>
    </NotificationBase>
  )
}